import React, { useEffect, useState } from "react";
import { ProgressBar, Step } from "react-step-progress-bar";
import { makeStyles } from "@material-ui/core/styles";
import arrow from "../../assets/img/arrow.svg";
import { useSelector } from "react-redux";
import { selectUser } from "redux/slices/userSlice";
import Tooltip from "@mui/material/Tooltip";
const HOUSE_OUTLINE_PATH =
  "M236-196h162v-236h164v236h162v-366L480-747.33 236-562.22V-196Zm-24 24v-402l268-203 268 203v402H538v-236H422v236H212Zm268-299.67Z";
const HOUSE_FILLED_PATH =
  "M39.5,43h-9c-1.381,0 -2.5,-1.119 -2.5,-2.5v-9c0,-1.105 -0.895,-2 -2,-2h-4c-1.105,0 -2,0.895 -2,2v9c0,1.381 -1.119,2.5 -2.5,2.5h-9c-1.381,0 -2.5,-1.119 -2.5,-2.5v-19.087c0,-2.299 1.054,-4.471 2.859,-5.893l14.212,-11.199c0.545,-0.428 1.313,-0.428 1.857,0l14.214,11.199c1.805,1.422 2.858,3.593 2.858,5.891v19.089c0,1.381 -1.119,2.5 -2.5,2.5z";

export const StartHouseIcon = ({ filled, fill, size, bgFill = "transparent" }) => {
  if (filled) {
    return (
      <svg width={size} height={size} viewBox="0 0 48 48" fill={fill} style={{ display: "block" }}>
        {bgFill !== "transparent" && (
          <path d="M8.5 43h31V21.4L24 8L8.5 21.4Z" fill={bgFill} />
        )}
        <path d={HOUSE_FILLED_PATH} fillRule="nonzero" />
      </svg>
    );
  }

  return (
    <svg width={size} height={size} viewBox="0 -960 960 960" style={{ display: "block" }}>
      {bgFill !== "transparent" && (
        <path d="M212-172v-402l268-203 268 203v402H212Z" fill={bgFill} />
      )}
      <path d={HOUSE_OUTLINE_PATH} fill={fill} />
    </svg>
  );
};
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import MaterialTable from "material-table";
import { getLocalization } from "util/table-utils";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import SkipStopModal from "./SkipStopModal";
import { skipStop } from "redux/slices/routeSlice";
import { useDispatch } from "react-redux";
import { skipOrder } from "redux/slices/orderSlice";
import { useTranslation } from "react-i18next";
import { setShowMessage } from "redux/slices/uiSlice";
import QRModal from "components/QRModal";
import EditIcon from "@material-ui/icons/Edit";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { PATHS } from "util/appConstants";
import { IconButton } from "@material-ui/core";
import {
  collectOrdersForStop,
  getAdditionalCustomerDisplayName,
  getDeliveryStatus,
  getPathwayStopCompletedAt,
  getStartHouseVisual,
  getStatusVisual,
  getStopPackageStats,
  getVisibleAdditionalCustomers,
  isPackageDelivered,
  isPathwayStopCompleted,
} from "util/stopStatusUtils";
import { shouldShowScanCodes } from "util/deliveryTimingConfigUtils";
import { getStopActionLabel } from "util/warehouseReturnUtils";
import {
  getDeliveryNotePackagesCount,
  getDeliveryNotesForStopDisplay,
  getOrdersForStopDisplay,
  getStopOrdersBreakdownLines,
  resolveOrderType,
  getStopRecordForOrder,
} from "util/pathwayOrderUtils";
import {
  buildStopLabelMap,
  formatStopTypeWithLabel,
  getDeliveryStartPathwayIndex,
  getDeliveryStartStop,
  normalizeRoutePathway,
} from "util/stopLabelUtils";
import { deliveryNoteIsAllBarcodePackages } from "util/scan-code-print";


const useStyles = makeStyles({
  squareStop: {
    width: "14px",
    height: "14px",
    border: "1px solid #6F9CEB",
    margin: "0 auto",
    cursor: "pointer",
    backgroundColor: "transparent",
    transition: "all 0.2s ease-in-out",
    borderRadius: "25%",
  },
  myCustomTooltip: {
    backgroundColor: "#93B5F0 !important",
    color: "#121212 !important",
    padding: "12px 16px !important",
    borderRadius: "4px !important",
    fontSize: "12px !important",
    fontFamily: "Roboto, sans-serif !important",
    boxShadow: "0px 2px 6px rgba(0,0,0,0.3) !important",
  },
  myCustomArrow: {
    color: "#93B5F0 !important",
  },
  _container: {
    backgroundColor: "#121212",
    padding: "60px 130px",
    minHeight: "60vh",
    "& .MuiInputBase-root": {
      color: "#F5F5F5",
    },
    "& .MuiPaper-elevation2": {
      boxShadow: "none",
    },
    "& .MuiTableCell-root": {
      border: "none",
      color: "white",
      fontSize: "12px",
      width: "unset !important",
    },
    "& .MuiTableSortLabel-root:hover": {
      color: "#F5F5F5",
    },
    "& .MuiTablePagination-root": {
      border: "none",
      color: "white",
    },
    "& .MuiPaper-root ": {
      backgroundColor: "#121212",
      color: "white",
    },
    "& .MuiInput-underline:before": {
      borderBottom: "1px solid #525252",
    },
    "& .MuiInput-underline:hover:before": {
      borderBottom: "1px solid #525252",
    },
    "& .MuiIconButton-root *.MuiSvgIcon-root , .MuiIconButton-root": {
      color: "#F5F5F5",
    },
    "& .MuiTableCell-alignLeft *.MuiSvgIcon-root": {
      color: "#ADADAD",
      width: "22px",
      height: "22px",
      cursor: "pointer",
    },
    "& .MuiTypography-root": {
      color: "#F5F5F5",
    },
  },
  _tourdetailbar: {
    background: "#6F9CEB",
    width: "255px",
    height: "70px",
    position: "absolute",
    right: 0,
    marginTop: "-240px",
    display: "flex",
    alignItems: "center",
    justifyContent: " space-around",
    color: "black",
    "&::before": {
      content: '""',
      height: 0,
      width: 0,
      position: "absolute",
      left: "46%",
      bottom: "-40px",
      border: "20px solid transparent",
      borderTopColor: "#6F9CEB",
      // borderRightColor: '#DA362A',
    },
  },
  _codetext: {
    fontSize: "15px",
  },
  _codedetail: {
    fontSize: "15px",
    fontWeight: "bold",
  },
  _1F1F1F: {
    background: "#1F1F1F",
  },
  _525252: {
    background: "#525252",
  },
  _textalignright: {
    textAlign: "right",
  },
  _edit: {
    background: "#6F9CEB",
    borderRadius: "50%",
    padding: "2px",
    width: "13px",
    height: "13px",
  },
  editIconButton: {
    background: "#6F9CEB",
    color: "#fff",
    "& .MuiSvgIcon-root": {
      color: "#fff",
    },
    borderRadius: "50%",
    width: 25,
    height: 25,
    minWidth: 25,
    padding: 0,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      background: "#5b8fd9",
    },
  },
  qrIcon: {
    color: "#fff",
    cursor: "pointer",
    "&:hover": {
      opacity: 0.9,
    },
  },
  _pointer: {
    cursor: "pointer",
  },
  _width111: "111px",
  _fontsize12: {
    fontSize: "12px",
    cursor: "pointer",
    height: "8px",
  },
});
const equalColStyle = {
  cellStyle: {
    width: "12.5%",
    maxWidth: "12.5%",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    padding: "8px 12px",
  },
  headerStyle: {
    width: "12.5%",
    maxWidth: "12.5%",
    padding: "8px 12px",
  },
};
const TableExpansionPanel = ({ rowData: rawRowData, scroll, redirectView, myDivToFocus }) => {
  const rowData = React.useMemo(() => normalizeRoutePathway(rawRowData), [rawRowData]);
  const classes = useStyles();
  const user = useSelector(selectUser);
  const dispatch = useDispatch();
  const [contentWidth, setContentWidth] = useState("100px");
  const [expanded, setExpanded] = useState(false);
  const [qrModalOpen, setQrModalOpen] = useState(false);
  const [skipModalOpen, setSkipModalOpen] = React.useState(false);
  const [currentCustomer, setCurrentCustomer] = useState(null);
  const [qrOrder, setQrOrder] = useState(null);
  const history = useHistory();
  const [selectedDNs, setSelectedDNs] = useState([]);
  const isNameLess = user.permissions?.routes?.name_less;
  const canOpenMap = user?.permissions?.routesMap || user?.permissions?.routes?.map;

  const openMapAtPathwayIndex = (pathwayIndex, pathwayStop) => {
    if (!canOpenMap || !redirectView) return;
    redirectView(pathwayStop ?? rowData.pathway?.[pathwayIndex] ?? null, rowData, pathwayIndex);
  };

  const handleSkipStop = async (reason) => {
    if (!currentCustomer) return;
    if (!reason) return;
    try {
      await dispatch(skipStop(rowData.id, currentCustomer.id, null, reason, false));
      dispatch(
        setShowMessage({
          description: "The stop has been skipped",
          type: "success",
        })
      );
      setSkipModalOpen(false);
    } catch (err) {
      console.error("Skip stop failed:", err);
    }
  };
  const { t } = useTranslation();

  const routeStarted = !!rowData?.start_date;
  const routeCompleted = !!rowData?.end_date || rowData?.progress === "Complete";
  const tourTypeCategory = rowData?.Tour?.tour_type_category ?? rowData?.tour_type_category ?? "delivery";
  const isScanCodesEnabledForDeparture = shouldShowScanCodes(
    rowData?.delivery_timing_config
  );
  const deliveryTimingConfig = rowData?.delivery_timing_config;
  const scanningCodesEnabled =
    deliveryTimingConfig?.permissions?.scanning_codes_enabled !== false &&
    deliveryTimingConfig?.permissions?.scanning_codes_enabled !== 0 &&
    deliveryTimingConfig?.permissions?.scanning_codes_enabled !== "0";

  const maxVisibleDNs = 2;
  const getOrderCustomerName = (order) => {
    if (!order) return "-";
    return (
      order?.Customer?.name ||
      "-"
    );
  };
  const handleEditOrder = (order) => {
    const queryParams = new URLSearchParams({
      from: 'reorderStopsModal',
      routeId: rowData.id,
      fromPage: history.location.pathname
    }).toString();
    history.push(`${PATHS.orders.edit.replace(":id", order.orderId)}?${queryParams}`);
  };
  const shouldHideStop = (stop) => {
    if (!isNameLess) return false;
    if (stop.id === null) return false;
    if (!stop.isNameHidden) return false;
    const visibleAdditional = getVisibleAdditionalCustomers(stop);
    return visibleAdditional.length === 0;
  };
  const isHiddenStop = (stop) => shouldHideStop(stop);
  const getStopDisplayName = (stop, stopIndex) => {
    if (isNameLess && stop?.isNameHidden) {
      const visible = getVisibleAdditionalCustomers(stop);
      const name = getAdditionalCustomerDisplayName(visible[0]);
      return name || stop?.name || `Stop ${stopIndex + 1}`;
    }
    return stop?.name || `Stop ${stopIndex + 1}`;
  };

  const deliveryStartIndex = React.useMemo(
    () => getDeliveryStartPathwayIndex(rowData),
    [rowData?.pathway]
  );

  const deliveryStartStop = React.useMemo(
    () => getDeliveryStartStop(rowData),
    [rowData, deliveryStartIndex]
  );

  const deliveryStartName =
    deliveryStartStop?.name || rowData?.Tour?.SupplierLocation?.name || "Start";

  const pathwayStops = React.useMemo(() => {
    const stops = Array.isArray(rowData?.pathway) ? rowData.pathway : [];
    return stops.map((stop, originalIndex) => ({ stop, originalIndex }));
  }, [rowData?.pathway]);

  const percentageProgress = React.useMemo(() => {
    const stops = rowData?.pathway || [];
    const hasLegacyStart = deliveryStartIndex === -1 && tourTypeCategory !== "pickup";
    const totalTimelineSteps = stops.length + (hasLegacyStart ? 1 : 0);
    if (stops.length === 0 || totalTimelineSteps === 0) return 0;
    if (!routeStarted) return 0;
    if (routeCompleted) return 100;

    let completedStepsCount = 0;

    if (hasLegacyStart && routeStarted) {
      completedStepsCount = 1;
    }

    for (let index = 0; index < stops.length; index++) {
      const stop = stops[index];

      const stopStatus = getDeliveryStatus({
        stop,
        routeStarted,
        routeCompleted,
        scanningCodesEnabled,
        route: rowData,
        pathwayIndex: index,
      });

      const allOrdersRemoved =
        (stop?.Orders || []).length > 0 &&
        (stop?.Orders || []).every((o) => !!o?.removed_at);

      const isProgressed =
        isPathwayStopCompleted(stop, { scanningCodesEnabled, route: rowData, pathwayIndex: index }) ||
        !!stop?.completed_at ||
        !!stop?.skipped_at ||
        (!allOrdersRemoved && ["delivered", "partial", "unsuccessful", "skipped"].includes(stopStatus));

      if (isProgressed) {
        completedStepsCount += 1;
      } else {
        break;
      }
    }

    if (completedStepsCount === 0) return 0;

    return Math.min(100, Math.max(0, (completedStepsCount / totalTimelineSteps) * 100));
  }, [
    rowData,
    routeStarted,
    routeCompleted,
    scanningCodesEnabled,
    deliveryStartIndex,
    tourTypeCategory,
  ]);

  const stopLabelMap = React.useMemo(
    () => buildStopLabelMap(rowData),
    [rowData?.pathway, rowData?.Tour?.tour_type, rowData?.tour_type]
  );

  const deliveryStartStopStatus = deliveryStartStop
    ? getDeliveryStatus({
      stop: deliveryStartStop,
      routeStarted,
      routeCompleted,
      scanningCodesEnabled,
      route: rowData,
      pathwayIndex: deliveryStartIndex,
    })
    : null;
  const startHouseVisual = getStartHouseVisual(deliveryStartStopStatus, {
    routeStarted,
    hasMergedStartStop: !!deliveryStartStop,
    deliveryStartStop,
    deliveryStartIndex,
  });

  const renderStopTooltipContent = (data, stopStatus, displayIndex) => (
    <div>
      <div><strong>{shouldHideStop(data) ? "" : getStopDisplayName(data, displayIndex)}</strong></div>
      <div style={{ marginTop: "4px" }}>
        <strong> {t("Stop Type")}:</strong>{" "}
        {formatStopTypeWithLabel(data, rowData, displayIndex, t)}
      </div>
      {data.skipped_at ? (
        <div style={{ marginTop: "4px" }}>
          Skipped At:{" "}
          {new Date(data.skipped_at)?.toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </div>
      ) : getPathwayStopCompletedAt(data) ? (
        <div style={{ marginTop: "4px" }}>
          <strong> {t("Completed")}:</strong>{" "}
          {new Date(getPathwayStopCompletedAt(data)).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          })}
        </div>
      ) : (
        data.eta && (
          <div style={{ marginTop: "4px" }}>
            {t("ETA")}:{" "}
            {new Date(data.eta)?.toLocaleString([], {
              day: "2-digit",
              month: "short",
              hour: "2-digit",
              minute: "2-digit",
            })}
          </div>
        )
      )}

      {(() => {
        const breakdownLines = getStopOrdersBreakdownLines(
          collectOrdersForStop(data, { isNameLess }),
          t,
          { isFixStop: data?.id === null }
        );
        if (!breakdownLines.length) return null;

        return breakdownLines.map((line, index) => (
          <div key={line.kind} style={{ marginTop: index === 0 ? "6px" : "4px" }}>
            <strong>{line.label}:</strong>{" "}
            {t("orders")} {line.orders} , {t("packages")} {line.packages}
          </div>
        ));
      })()}

      <div style={{ marginTop: "6px" }}>
        <strong>{t("Status")}:</strong>{" "}
        {{
          skipped: t("Stop Skipped"),
          delivered: t("Completed"),
          partial: t("Partial"),
          unsuccessful: t("Unsuccessful"),
          order_removed: t("Order Removed"),
          ready: t("In Progress"),
          in_progress: t("In Progress"),
        }[stopStatus] || t("In Progress")}
      </div>

      {(data.skipping_reason || data.Orders?.some((o) => o.skipping_reason)) && (
        <div style={{ marginTop: "4px" }}>
          <strong>{t("Reason")}:</strong>{" "}
          {t(data.skipping_reason) ||
            t(data.Orders.find((o) => o.skipping_reason)?.skipping_reason)}
        </div>
      )}
    </div>
  );

  const richTooltipProps = {
    placement: "top",
    arrow: true,
    interactive: true,
    componentsProps: {
      tooltip: {
        sx: {
          backgroundColor: "#93B5F0 !important",
          color: "#000 !important",
          fontSize: "0.75rem",
        },
      },
      arrow: {
        sx: {
          color: "#93B5F0 !important",
        },
      },
    },
    classes: {
      tooltip: classes.myCustomTooltip,
      arrow: classes.myCustomArrow,
    },
  };

  const expandedOrders = React.useMemo(() => {
    const stops = rowData?.pathway || [];
    return stops.flatMap((stop, stopIndex) => {
      const orders = getOrdersForStopDisplay(
        stop,
        collectOrdersForStop(stop, { isNameLess })
      );
      return orders.map((order) => {
        const deliveryNotes = getDeliveryNotesForStopDisplay(stop, order) || [];
        const deliveryNoteNumbers = deliveryNotes.map((dn) => dn?.delivery_note_number).filter(Boolean);
        const totalPackagesCount = deliveryNotes.reduce((sum, dn) => sum + getDeliveryNotePackagesCount(dn), 0);
        const totalDeliveredCount = deliveryNotes.reduce((sum, dn) => {
          return sum + (Array.isArray(dn?.Packages) && dn.Packages.length
            ? dn.Packages.filter((p) => isPackageDelivered(p, order, { scanningCodesEnabled })).length
            : 0);
        }, 0);
        const allPackages = deliveryNotes.flatMap((dn) => dn?.Packages || []);
        const packageIds = allPackages.map((p) => p.package_id || p.qr_code || p.id).filter(Boolean);

        const status = getDeliveryStatus({
          order,
          deliveryNote: deliveryNotes[0],
          stop,
          routeStarted,
          routeCompleted,
          scanningCodesEnabled,
          route: rowData,
          pathwayIndex: stopIndex,
        });

        return {
          _stopIndex: stopIndex,
          stopName: getStopDisplayName(stop, stopIndex),
          isStopHidden: isHiddenStop(stop),
          orderId: order?.id ?? "-",
          orderType: formatStopTypeWithLabel(stop, rowData, stopIndex, t),
          stopAction:
            stop?.id === null
              ? order?.stop_action ?? order?.stopAction ?? null
              : null,
          stopActionLabel:
            stop?.id === null
              ? getStopActionLabel(order?.stop_action ?? order?.stopAction, t)
              : resolveOrderType(order) === "return"
                ? t("Return")
                : resolveOrderType(order) === "pickup"
                  ? t("Pickup")
                  : t("Delivery"),
          customerName: getOrderCustomerName(order),
          supplierLocation: order?.orignalSupplierName
            ? `${order.orignalSupplierName}`
            : order?.supplier_location_name || "-",
          deliveryNoteNumbers,
          deliveryNoteNumber: deliveryNoteNumbers.join(", ") || "-",
          deliveryNoteId: deliveryNotes.map((dn) => dn?.id).filter(Boolean).join(","),
          packages: totalPackagesCount,
          deliveredCount: totalDeliveredCount,
          status,
          isRouteStarted: !!rowData?.start_date,
          rawOrder: order,
          rawDN: deliveryNotes[0],
          rawDNs: deliveryNotes,
          packageIds,
          stop,
          routeCompleted
        };
      });
    });
  }, [rowData, t, isNameLess, scanningCodesEnabled]);
  const expandedOrdersWithHeaders = React.useMemo(() => {
    const grouped = expandedOrders.reduce((acc, row) => {
      if (!acc[row.stopName]) acc[row.stopName] = [];
      acc[row.stopName].push(row);
      return acc;
    }, {});

    const rows = [];
    Object.entries(grouped).forEach(([stopName, items]) => {
      const isStopHidden = items[0]?.isStopHidden === true;
      const stopIndex = items[0]?._stopIndex;
      const stop = typeof stopIndex === "number" && rowData.pathway ? rowData.pathway[stopIndex] : rowData.pathway.find((s) => s.name === stopName);
      const stopAddress = [stop?.street, stop?.street_number != null ? `${stop.street_number},` : "", stop?.zipcode, stop?.city].filter(Boolean).join(" ").trim() || "-";
      const routeCompleted = !!rowData?.end_date || rowData?.progress === "Complete";
      rows.push({
        isStopHeader: true,
        stopName,
        stopAddress,
        isStopHidden,
        stop,
        stopIndex,
        routeCompleted
      });

      rows.push(
        ...items.map((r) => ({
          ...r,
          isStopHeader: false,
        }))
      );
    });
    return rows;
  }, [expandedOrders, rowData.pathway]);
  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;
      setContentWidth(screenWidth < 1200 ? "50px" : "100px");
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div
      style={{
        padding: "15px",
        background: rowData.tableData.id % 2 === 0 ? " #1F1F1F " : "#525252",
        position: "relative",
      }}
    >
      <>
        <div
          style={{
            width: "5%",
            float: "left",
            margin: "25px 0",
            textAlign: "center",
          }}
        >
          <div style={{ display: "inline-block" }} onClick={() => scroll(-12000, rowData)}>
            <img alt="icon" src={arrow} className={classes._fontsize12} style={{ transform: "rotate(180deg)" }} />
            <img alt="icon" src={arrow} className={classes._fontsize12} style={{ transform: "rotate(180deg)" }} />
          </div>
          <img
            alt="icon"
            src={arrow}
            onClick={() => scroll(-100, rowData)}
            className={classes._fontsize12}
            style={{ marginLeft: "15px", transform: "rotate(180deg)" }}
          />
        </div>
        <div
          style={{
            width: "5%",
            float: "right",
            margin: "25px 0",
            textAlign: "center",
          }}
        >
          <img
            alt="icon"
            style={{ marginRight: "15px" }}
            src={arrow}
            onClick={() => scroll(100, rowData)}
            className={classes._fontsize12}
          />
          <div style={{ display: "inline-block" }} onClick={() => scroll(12000, rowData)}>
            <img alt="icon" src={arrow} className={classes._fontsize12} />
            <img alt="icon" src={arrow} className={classes._fontsize12} />
          </div>
        </div>
        <div
          style={{
            position: "absolute",
            left: "50%",
            transform: "translateX(-50%)",
            top: "100px",
            zIndex: 5,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {expanded ? (
            <KeyboardArrowUpIcon
              onClick={() => setExpanded((prev) => !prev)}
              sx={{ fontSize: 32, color: "white", cursor: "pointer" }}
            />
          ) : (
            <KeyboardArrowDownIcon
              onClick={() => setExpanded((prev) => !prev)}
              sx={{ fontSize: 32, color: "white", cursor: "pointer" }}
            />
          )}
        </div>
        <div
          ref={myDivToFocus[rowData.tableData.id]}
          className={"route-timeline-scroll"}
          style={{
            maxWidth: "90%",
            overflowX: "auto",
            overflowY: "hidden",
            scrollBehavior: "smooth",
            // Extra space so start/supplier location + customer names stay above the scrollbar
            paddingBottom: "52px",
            marginBottom: "8px",
          }}
        >
          <div style={{ paddingBottom: "4px" }}>
            <ProgressBar
              className={"margin-30"}
              percent={percentageProgress}
              width={`${(pathwayStops.length + (deliveryStartIndex === -1 && tourTypeCategory !== "pickup" ? 1 : 0)) * 10}%`}
              height={2}
              filledBackground="#4caf50"
              unfilledBackground="#555"
            >
              {(() => {
                const steps = [];

                if (deliveryStartIndex === -1 && tourTypeCategory !== "pickup") {
                  const houseSize = startHouseVisual.filled ? 24 : 29;
                  steps.push(
                    <Step transition="scale" key="start-legacy">
                      {() => (
                        <div style={{ filter: "grayscale(0%)" }}>
                          <div
                            style={{
                              marginTop: "-14px",
                              position: "relative",
                              textAlign: "center",
                              width: "100%",
                            }}
                          >
                            L1
                          </div>
                          <Tooltip
                            title={deliveryStartName}
                            placement="top"
                            arrow
                            interactive
                            classes={{
                              tooltip: classes.myCustomTooltip,
                              arrow: classes.myCustomArrow,
                            }}
                          >
                            <div
                              style={{
                                width: houseSize,
                                height: houseSize,
                                margin: "0 auto",
                                display: "block",
                                cursor: "default",
                              }}
                            >
                              <StartHouseIcon
                                filled={startHouseVisual.filled}
                                fill={startHouseVisual.fill}
                                size={houseSize}
                                bgFill={rowData.tableData.id % 2 === 0 ? "#1F1F1F" : "#525252"}
                              />
                            </div>
                          </Tooltip>

                          <Tooltip
                            title={deliveryStartName}
                            placement="bottom"
                            arrow
                            interactive
                            classes={{
                              tooltip: classes.myCustomTooltip,
                              arrow: classes.myCustomArrow,
                            }}
                          >
                            <div
                              style={{
                                position: "absolute",
                                marginTop: "8px",
                                width: contentWidth,
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                cursor: "default",
                                zIndex: 2,
                                lineHeight: 1.2,
                              }}
                            >
                              {deliveryStartName}
                            </div>
                          </Tooltip>
                        </div>
                      )}
                    </Step>
                  );
                }

                pathwayStops.forEach(({ stop: data, originalIndex }) => {
                  if (originalIndex === deliveryStartIndex && tourTypeCategory !== "pickup") {
                    const houseSize = startHouseVisual.filled ? 24 : 29;
                    const isVirtualStart = deliveryStartStop?.virtual === true;
                    const isStartClickable = canOpenMap && !isVirtualStart;
                    steps.push(
                      <Step transition="scale" key={`start-${originalIndex}`}>
                        {() => (
                          <div style={{ filter: "grayscale(0%)" }}>
                            <div
                              style={{
                                marginTop: "-14px",
                                position: "relative",
                                textAlign: "center",
                                width: "100%",
                              }}
                            >
                              {stopLabelMap.get(originalIndex) || "L1"}
                            </div>
                            <Tooltip
                              title={
                                deliveryStartStop
                                  ? renderStopTooltipContent(
                                    deliveryStartStop,
                                    deliveryStartStopStatus,
                                    originalIndex
                                  )
                                  : deliveryStartName
                              }
                              {...(deliveryStartStop
                                ? richTooltipProps
                                : {
                                  placement: "top",
                                  arrow: true,
                                  interactive: true,
                                  classes: {
                                    tooltip: classes.myCustomTooltip,
                                    arrow: classes.myCustomArrow,
                                  },
                                })}
                            >
                              <div
                                onClick={() => {
                                  if (!isStartClickable) return;
                                  openMapAtPathwayIndex(deliveryStartIndex, deliveryStartStop);
                                }}
                                style={{
                                  width: houseSize,
                                  height: houseSize,
                                  margin: "0 auto",
                                  display: "block",
                                  cursor: isStartClickable ? "pointer" : "default",
                                }}
                              >
                                <StartHouseIcon
                                  filled={startHouseVisual.filled}
                                  fill={startHouseVisual.fill}
                                  size={houseSize}
                                  bgFill={rowData.tableData.id % 2 === 0 ? "#1F1F1F" : "#525252"}
                                />
                              </div>
                            </Tooltip>

                            <Tooltip
                              title={deliveryStartName}
                              placement="bottom"
                              arrow
                              interactive
                              classes={{
                                tooltip: classes.myCustomTooltip,
                                arrow: classes.myCustomArrow,
                              }}
                            >
                              <div
                                onClick={() => {
                                  if (!isStartClickable) return;
                                  openMapAtPathwayIndex(deliveryStartIndex, deliveryStartStop);
                                }}
                                style={{
                                  position: "absolute",
                                  marginTop: "8px",
                                  width: contentWidth,
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  cursor: isStartClickable ? "pointer" : "default",
                                  zIndex: 2,
                                  lineHeight: 1.2,
                                }}
                              >
                                {deliveryStartName}
                              </div>
                            </Tooltip>
                          </div>
                        )}
                      </Step>
                    );
                    return;
                  }

                  const stopStatus = getDeliveryStatus({
                    stop: data,
                    routeStarted,
                    routeCompleted,
                    scanningCodesEnabled,
                    route: rowData,
                    pathwayIndex: originalIndex,
                  });
                  const { className: statusClass } = getStatusVisual(stopStatus, "timeline");
                  const stopClassName = data?.id === null ? `${classes.squareStop} ${statusClass}` : statusClass;
                  const stopLabel = stopLabelMap.get(originalIndex) ?? String(originalIndex + 1);
                  const stopDisplayName = shouldHideStop(data)
                    ? ""
                    : getStopDisplayName(data, originalIndex);

                  steps.push(
                    <Step transition="scale" key={data?.id ?? `step-${originalIndex}`}>
                      {({ accomplished }) => (
                        <div
                          style={{
                            filter: `grayscale(${accomplished ? 0 : 40}%)`,
                          }}
                        >
                          <div
                            style={{
                              marginTop: "-14px",
                              position: "relative",
                              textAlign: "center",
                              width: "100%",
                            }}
                          >
                            {stopLabel}
                          </div>

                          <Tooltip
                            title={renderStopTooltipContent(data, stopStatus, originalIndex)}
                            {...richTooltipProps}
                          >
                            <div
                              onClick={() => {
                                if (isHiddenStop(data)) return;
                                openMapAtPathwayIndex(originalIndex, data);
                              }}
                              style={{
                                background: rowData.tableData.id % 2 === 0 ? "#1F1F1F" : "#525252",
                                cursor: "pointer",
                              }}
                              className={stopClassName}
                            />
                          </Tooltip>
                          <Tooltip
                            title={stopDisplayName}
                            placement="bottom"
                            arrow
                            classes={{
                              tooltip: classes.myCustomTooltip,
                              arrow: classes.myCustomArrow,
                            }}
                          >
                            <div
                              style={{
                                position: "absolute",
                                marginTop: "8px",
                                width: contentWidth,
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                zIndex: 2,
                                lineHeight: 1.2,
                              }}
                            >
                              {stopDisplayName}
                            </div>
                          </Tooltip>
                        </div>
                      )}
                    </Step>
                  );
                });

                return steps;
              })()}
            </ProgressBar>
          </div>
        </div>
        <div
          style={{
            marginTop: expanded ? "20px" : 0,
            padding: expanded ? "20px" : "0 20px",
            background: rowData.tableData.id % 2 === 0 ? " #1F1F1F " : "#525252",
            maxHeight: expanded ? "none" : 0,
            overflow: "hidden",
            opacity: expanded ? 1 : 0,
            transition: "max-height 0.35s ease, padding 0.35s ease, margin 0.35s ease, opacity 0.25s ease, border-color 0.3s ease",
            pointerEvents: expanded ? "auto" : "none",
          }}
        >
          <MaterialTable
            title="Orders"
            localization={getLocalization(t)}
            columns={[
              {
                title: t("Supplier Location"),
                field: "supplierLocation",
                ...equalColStyle,
                render: (row) => {
                  if (row.isStopHeader) {
                    return (
                      <div
                        style={{
                          fontWeight: "bold",
                          fontSize: "15px",
                          padding: "6px 0",
                          display: "flex",
                          flexDirection: "column",
                          maxWidth: 100,
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <span title={(row.stopName || "-") + " / " + (row.stopAddress ?? "-")}>{(row.stopName || "-") + " / " + (row.stopAddress ?? "-")}</span>
                      </div>
                    );
                  }
                  return (
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <div style={{ maxWidth: 260, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={row.supplierLocation ?? "-"}>{row.supplierLocation ?? "-"}</div>
                    </div>
                  );
                },
              },
              {
                title: t("Order Type"),
                field: "orderType",
                ...equalColStyle,
                render: (row) =>
                  row.isStopHeader
                    ? null
                    : (
                      <div
                        style={{
                          cursor: "pointer",
                          display: "block",
                          maxWidth: "100%",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap"
                        }}
                        title={row.orderType ?? ""}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (user?.permissions?.routesMap || user?.permissions?.routes?.map) {
                            redirectView && redirectView(row.rawOrder, rowData, row._stopIndex);
                          }
                        }}
                      >
                        {row.orderType}
                      </div>
                    ),
              },
              {
                title: t("stop_action.column_title"),
                field: "stopActionLabel",
                ...equalColStyle,
                render: (row) => {
                  if (row.isStopHeader) return null;
                  return (
                    <div
                      style={{ maxWidth: 160, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}
                      title={row.stopActionLabel ?? "-"}
                    >
                      {row.stopActionLabel ?? "-"}
                    </div>
                  );
                },
              },
              {
                title: t("Customer"),
                field: "customerName",
                ...equalColStyle,
                render: (row) => {
                  if (row.isStopHeader) return null;
                  return (
                    <div style={{ maxWidth: 260, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={row.customerName ?? "-"}>
                      {row.customerName ?? "-"}
                    </div>
                  );
                },
              },
              {
                title: t("Delivery Note Number"),
                field: "deliveryNumbers",
                ...equalColStyle,
                render: (row) => {
                  if (row.isStopHeader) return null;
                  const notes =
                    Array.isArray(row.deliveryNoteNumbers) && row.deliveryNoteNumbers.length > 0
                      ? row.deliveryNoteNumbers
                      : row.deliveryNoteNumber && row.deliveryNoteNumber !== "-"
                        ? row.deliveryNoteNumber.split(", ").map((s) => s.trim()).filter(Boolean)
                        : [];
                  const hasNotes = notes.length > 0;
                  const tooltipContent = hasNotes ? (
                    <div style={{ padding: "4px", maxHeight: "250px", overflowY: "auto" }}>
                      <div style={{ fontWeight: "bold", marginBottom: "4px" }}>
                        {t("Delivery Notes")}:
                      </div>
                      {notes.map((dn, index) => (
                        <div key={index} style={{ fontSize: "12px", fontFamily: "monospace", whiteSpace: "nowrap" }}>
                          - {dn}
                        </div>
                      ))}
                    </div>
                  ) : "";

                  return (
                    <Tooltip
                      title={tooltipContent}
                      disableHoverListener={!hasNotes}
                      disableFocusListener={!hasNotes}
                      disableTouchListener={!hasNotes}
                      {...richTooltipProps}
                    >
                      <div
                        style={{
                          maxWidth: 180,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          cursor: hasNotes ? "help" : "default",
                        }}
                      >
                        {row.deliveryNoteNumber || "-"}
                      </div>
                    </Tooltip>
                  );
                },
              },
              {
                title: t("Packages Amount"),
                field: "packages",
                ...equalColStyle,
                cellStyle: { ...equalColStyle.cellStyle, textAlign: "left" },
                type: "numeric",
                render: (row) => {
                  if (row.isStopHeader) return null;
                  const hasPackages = Array.isArray(row.packageIds) && row.packageIds.length > 0;
                  const tooltipContent = hasPackages ? (
                    <div style={{ padding: "4px" }}>
                      <div style={{ fontWeight: "bold", marginBottom: "4px" }}>{t("Package IDs")}:</div>
                      {row.packageIds.map((id, index) => (
                        <div key={index} style={{ fontSize: "12px", fontFamily: "monospace" }}>
                          - {id}
                        </div>
                      ))}
                    </div>
                  ) : "";

                  return (
                    <Tooltip
                      title={tooltipContent}
                      disableHoverListener={!hasPackages}
                      disableFocusListener={!hasPackages}
                      disableTouchListener={!hasPackages}
                      {...richTooltipProps}
                    >
                      <div style={{ textAlign: "left", width: "100%", cursor: hasPackages ? "help" : "default" }}>
                        {row.packages} {t("Packages")}
                      </div>
                    </Tooltip>
                  );
                }
              },
              {
                title: t("Status"),
                field: "status",
                ...equalColStyle,
                render: (row) =>
                  row.isStopHeader
                    ? null
                    : row.status
                      ? ({
                        skipped: t("Stop Skipped"),
                        delivered: t("Completed"),
                        partial: t("Partial"),
                        unsuccessful: t("Unsuccessful"),
                        order_removed: t("Order Removed"),
                        ready: row.isRouteStarted
                          ? (row.stop?.route_type?.startsWith("pickup")
                            ? t("Handover In Progress")
                            : t("In Progress"))
                          : t("Ready"),
                        in_progress: row.stop?.route_type?.startsWith("pickup")
                          ? t("Handover In Progress")
                          : t("In Progress"),
                        loaded: t("Loaded"),
                      }[row.status] || String(row.status).toUpperCase())
                      : "",
              },
              {
                title: t("QR"),
                field: "qr",
                ...equalColStyle,
                render: (row) => {
                  if (row.isStopHeader) return null;
                  const isOrderRemoved = !!row.rawOrder?.removed_at;
                  const isStopSkipped = !!row.stop?.skipped_at;
                  const isStopCompleted = isPathwayStopCompleted(row.stop, rowData);

                  const isPickup = row.rawOrder?.order_type === "pickup" || row.rawOrder?.stop_action === "pickup" || row.rawOrder?.stopAction === "pickup";
                  const isReturn = row.rawOrder?.order_type === "return" || !!row.rawOrder?.is_return;
                  const isDelivery = !isPickup && !isReturn;
                  const routeType = rowData?.Tour?.tour_type_category ?? rowData?.tour_type_category ?? "delivery";
                  const isTypeAllowed = isPickup || isReturn || (isDelivery && routeType === "delivery");

                  const isRouteFinished = !!rowData?.end_date || rowData?.progress === "Complete" || rowData?.progress === "Completed" || rowData?.progress === "Archived";
                  if (isRouteFinished) return null;

                  const isEditDisabled = isStopCompleted || isOrderRemoved || isStopSkipped || !isTypeAllowed || (routeStarted && routeType === "delivery");

                  return (
                    <Tooltip title={t("Edit Order")} placement="left">
                      <IconButton
                        className={classes.editIconButton}
                        size="small"
                        disabled={isEditDisabled}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (!isEditDisabled) {
                            handleEditOrder(row);
                          }
                        }}
                      >
                        <EditIcon fontSize="small" style={{ color: "#fff" }} />
                      </IconButton>
                    </Tooltip>
                  );
                },
              },
              {
                title: t("Skip"),
                field: "skip",
                ...equalColStyle,
                render: (row) => {
                  if (row.isStopHeader) {
                    if (row.isStopHidden) return null;
                    const stop = row.stop;
                    if (!stop || stop.id === null) return null;
                    if (stop.skipped_at) return null;
                    const hasRemovedOrder = (stop?.Orders || []).some((o) => !!o?.removed_at);
                    if (hasRemovedOrder) return null;
                    const stopStatus = getDeliveryStatus({
                      stop,
                      routeStarted,
                      routeCompleted: row.routeCompleted,
                      scanningCodesEnabled,
                      route: rowData,
                      pathwayIndex: row.stopIndex,
                    });
                    if (
                      stopStatus === "partial" ||
                      stopStatus === "order_removed" ||
                      stopStatus === "unsuccessful" ||
                      stopStatus === "delivered"
                    ) {
                      return null;
                    }
                    const stats = getStopPackageStats(stop, { isNameLess, scanningCodesEnabled, route: rowData, pathwayIndex: row.stopIndex });
                    const isCompleted =
                      (stats.totalPackages > 0 &&
                        stats.deliveredPackages === stats.totalPackages) || row.routeCompleted;
                    if (isCompleted) return null;

                    const isPartialDelivery =
                      stats.totalPackages > 0 &&
                      stats.deliveredPackages > 0 &&
                      stats.deliveredPackages < stats.totalPackages;
                    if (isPartialDelivery) return null;
                    return (
                      <button
                        style={{
                          padding: "4px 8px",
                          background: "#6F9CEB",
                          cursor: "pointer",
                          color: "white",
                          border: "none",
                          borderRadius: "4px",
                          fontSize: "11px",
                        }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setCurrentCustomer(stop);
                          setSkipModalOpen(true);
                        }}
                      >
                        {t("Skip Stop")}
                      </button>
                    );
                  }

                  const order = row.rawOrder;
                  if (!order) return null;
                  const isAtbasScanImport = order?.created_via === "import_atbas_scan";
                  const allBarcodeDn = deliveryNoteIsAllBarcodePackages(row.rawDN?.Packages);
                  const hasNoPackages = (row.packages ?? 0) === 0;
                  const qrPdfDisabled = allBarcodeDn || hasNoPackages;
                  const qrTooltip = hasNoPackages
                    ? t("qr_print_unavailable_no_packages")
                    : allBarcodeDn
                      ? t("qr_print_unavailable_atbas_scan_import")
                      : "";
                  return (
                    <>  <button
                      style={{
                        padding: "4px 8px",
                        background: "#6F9CEB",
                        cursor: "pointer",
                        color: "white",
                        border: "none",
                        borderRadius: "4px",
                        fontSize: "11px",
                        display: "none",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        if (!row.raw) return;
                        const reason = "manual_skip";
                        dispatch(skipOrder(rowData.id, row.raw.id, reason));
                      }}
                    >
                      {t("Skip Order")}
                    </button>
                      {/* todo: apply logic to determine if order can be skipped */}
                      {isScanCodesEnabledForDeparture && (
                        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                          <Tooltip
                            title={
                              <div
                                style={{
                                  maxWidth: 280,
                                  fontSize: "0.75rem",
                                  lineHeight: 1.45,
                                }}
                              >
                                {t("qr_print_unavailable_atbas_scan_import")}
                              </div>
                            }
                            placement="top"
                            arrow
                            interactive
                            disableHoverListener={!isAtbasScanImport}
                            disableFocusListener={!isAtbasScanImport}
                            disableTouchListener={!isAtbasScanImport}
                            classes={{
                              tooltip: classes.myCustomTooltip,
                              arrow: classes.myCustomArrow,
                            }}
                            componentsProps={{
                              tooltip: {
                                sx: {
                                  backgroundColor: "#93B5F0 !important",
                                  color: "#121212 !important",
                                  fontSize: "0.75rem",
                                },
                              },
                              arrow: {
                                sx: {
                                  color: "#93B5F0 !important",
                                },
                              },
                            }}
                          >
                            <span
                              style={{
                                display: "inline-flex",
                                cursor: isAtbasScanImport ? "not-allowed" : "pointer",
                                opacity: isAtbasScanImport ? 0.35 : 1,
                              }}
                            >
                              <QrCode2Icon
                                onClick={async (e) => {
                                  e.stopPropagation();
                                  if (isAtbasScanImport) return;
                                  try {
                                    const response = await fetch(
                                      `${import.meta.env.VITE_API}routes/scan-codes-flexible`,
                                      {
                                        method: "POST",
                                        headers: {
                                          "Content-Type": "application/json",
                                          Authorization: `Bearer ${localStorage.getItem("token")}`,
                                        },
                                        body: JSON.stringify({
                                          orderId: order?.id,
                                          deliveryNoteIds: [row.deliveryNoteId],
                                        }),
                                      }
                                    );

                                    if (!response.ok) throw new Error("Failed to generate QR PDF");
                                    const blob = await response.blob();
                                    const pdfURL = window.URL.createObjectURL(blob);
                                    window.open(pdfURL);
                                  } catch (err) {
                                    console.error("QR PRINT ERROR:", err);
                                  }
                                }}
                                className={classes.qrIcon}
                                style={{ color: "white", cursor: isAtbasScanImport ? "not-allowed" : "pointer" }}
                              />
                            </span>
                          </Tooltip>
                        </div>
                      )}
                    </>
                  );
                }
              }
            ]}
            data={expandedOrdersWithHeaders.filter((r) => {
              if (isNameLess && r.isStopHidden) return false;
              return true;
            })}
            options={{
              tableLayout: "fixed",
              padding: "dense",
              cellStyle: equalColStyle.cellStyle,
              search: false,
              paging: false,
              toolbar: false,
              headerStyle: {
                display: "none",
              },
              rowStyle: (rowData) => ({
                background: "transparent",
                fontWeight: rowData.isStopHeader ? "bold" : "normal",
                pointerEvents: rowData.isStopHidden ? "none" : "auto",
              }),
            }}
            style={{ background: "transparent", color: "white" }}
          />
        </div>
      </>
      <QRModal
        open={qrModalOpen}
        onClose={() => setQrModalOpen(false)}
        qrOrder={qrOrder}
        selectedDNs={selectedDNs}
        setSelectedDNs={setSelectedDNs}
      />
      <SkipStopModal
        open={skipModalOpen}
        onClose={() => setSkipModalOpen(false)}
        onSkipStop={handleSkipStop}
        customerId={currentCustomer?.id}
        customerName={currentCustomer?.name || "-"}
        showStopOptions={currentCustomer?.id ? false : true}
      />
    </div>

  );
};

export default TableExpansionPanel;